export default __webpack_public_path__ + "static/media/xbox_store.907ce46b.svg";